const ERROR_MAP = {
  INVALID_CREDENTIALS: 'არასწორი პირადი ნომერი ან პაროლი',
  WRONG_CURRENT_PASSWORD: 'მიმდინარე პაროლი არასწორია',
  PERSONAL_NUMBER_EXISTS: 'ეს პირადი ნომერი უკვე რეგისტრირებულია',
  NOT_FOUND: 'მონაცემი ვერ მოიძებნა',
  UNAUTHORIZED: 'გთხოვთ გაიაროთ ავტორიზაცია',
  INVALID_TOKEN: 'სესია ამოიწურა, გთხოვთ თავიდან შეხვიდეთ',
  ADMIN_ONLY: 'ეს მოქმედება მხოლოდ ადმინისტრატორს შეუძლია',
  SESSION_ALREADY_ACTIVE: 'სამუშაო სესია უკვე აქტიურია',
  NO_ACTIVE_SESSION: 'აქტიური სამუშაო სესია არ მოიძებნა',
  NOT_ON_BREAK: 'ამჟამად შესვენებაზე არ იმყოფებით',
  VALIDATION_ERROR: 'გთხოვთ სწორად შეავსოთ ველები',
  SUPERADMIN_ONLY: 'ეს მოქმედება მხოლოდ ადმინისტრატორს შეუძლია',
  NO_ATTACHMENTS_IN_SESSION: 'სამუშაოს დასრულებამდე მინიმუმ ერთი დანართი უნდა შეავსოთ',
  FORBIDDEN: 'ეს მოქმედება აკრძალულია',
  USER_BLOCKED: 'თქვენი ანგარიში დაბლოკილია, მიმართეთ ადმინისტრატორს',
  WORK_SESSION_REQUIRED: 'წაშლა შესაძლებელია მხოლოდ აქტიური სამუშაო სესიის დროს',
};

export const getErrorMessage = (error) => {
  const data = error?.response?.data;
  const code = data?.error || error?.message || '';
  if (code === 'VALIDATION_ERROR' && data?.details?.length) {
    return data.details[0];
  }
  return ERROR_MAP[code] || code || 'დაფიქსირდა შეცდომა';
};
